export const createOrderStep1Validator = (city, street, buildingNumber) => {
  const cityDropdown = document.getElementById("city");
  const streetInput = document.getElementById("street");
  const buildingNumberInput = document.getElementById("buildingNumber");

  if (!city) {
    if (cityDropdown) {
      cityDropdown.scrollIntoView({behavior: 'smooth'});
      // City is now a text input (auto-filled from Google Places); fall back to
      // the dropdown button styling only when present.
      const target = cityDropdown.querySelector("input") || cityDropdown.querySelector("div");
      if (target) {
        target.style.border = "1px solid #F04438";
        target.style.borderColor = "#F04438";
      }

      let errorMessageSpan = cityDropdown.querySelector(":scope > span");
      if (!errorMessageSpan) {
        errorMessageSpan = document.createElement("span");
        errorMessageSpan.textContent = "Заповніть це поле";
        errorMessageSpan.style.color = "#F04438";
        errorMessageSpan.style.fontSize = "14px";
        errorMessageSpan.style.fontWeight = "500";
        errorMessageSpan.style.lineHeight = "20px"; /* 142.857% */
        cityDropdown.appendChild(errorMessageSpan);
      }
    }

    return false;
  }

  if (!street) {
    if (streetInput) {
      streetInput.scrollIntoView({behavior: 'smooth', block: 'center'});
      const inputElement = streetInput.querySelector("input");
      if (inputElement) {
        inputElement.style.border = "1px solid #F04438";
      }

      let errorMessageSpan = streetInput.querySelector("span");
      if (!errorMessageSpan) {
        errorMessageSpan = document.createElement("span");
        errorMessageSpan.textContent = "Заповніть це поле";
        errorMessageSpan.style.color = "#F04438";
        errorMessageSpan.style.fontSize = "14px";
        errorMessageSpan.style.fontWeight = "500";
        errorMessageSpan.style.lineHeight = "20px"; /* 142.857% */
        streetInput.appendChild(errorMessageSpan);
      }
    }

    return false;
  }

  if (!buildingNumber) {
    if (buildingNumberInput) {
      buildingNumberInput.scrollIntoView({behavior: 'smooth', block: 'center'});
      const inputElement = buildingNumberInput.querySelector("input");
      if (inputElement) {
        inputElement.style.border = "1px solid #F04438";
      }

      let errorMessageSpan = buildingNumberInput.querySelector("span");
      if (!errorMessageSpan) {
        errorMessageSpan = document.createElement("span");
        errorMessageSpan.textContent = "Заповніть це поле";
        errorMessageSpan.style.color = "#F04438";
        errorMessageSpan.style.fontSize = "14px";
        errorMessageSpan.style.fontWeight = "500";
        errorMessageSpan.style.lineHeight = "20px"; /* 142.857% */
        buildingNumberInput.appendChild(errorMessageSpan);
      }
    }

    return false;
  }

  return true;
}
